"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var LoginOpened32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("path", { d: "M10.894 0c4.902 0 7.299 3.093 7.094 9.025C20.192 9.24 22 10.9 22 12.898v11.216C22 26.257 19.92 28 17.5 28h-13C2.08 28 0 26.257 0 24.114V12.886C0 10.743 2.08 9 4.5 9h12.478c.194-5.382-1.802-7.947-6.084-7.947-3.557 0-5.316 1.311-5.892 4.595a.507.507 0 01-.587.423.525.525 0 01-.407-.613C4.678 1.64 6.878 0 10.894 0zM17.5 10h-13C2.58 10 1 11.351 1 12.886v11.228C1 25.649 2.58 27 4.5 27h13c1.92 0 3.5-1.351 3.5-2.886V12.898C21 11.36 19.417 10 17.5 10zM11 15a2 2 0 012 2v4a2 2 0 11-4 0v-4a2 2 0 012-2zm0 1a1 1 0 00-1 1v4a1 1 0 002 0v-4a1 1 0 00-1-1z", id: "login-opened-32_svg__a" })),
    react_1.default.createElement("g", { transform: "translate(5 2)", fill: "currentColor", fillRule: "evenodd" },
        react_1.default.createElement("mask", { id: "login-opened-32_svg__b" },
            react_1.default.createElement("use", { xlinkHref: "#login-opened-32_svg__a" })),
        react_1.default.createElement("use", { fillRule: "nonzero", xlinkHref: "#login-opened-32_svg__a" }),
        react_1.default.createElement("g", { mask: "url(#login-opened-32_svg__b)" },
            react_1.default.createElement("path", { d: "M-5-2h32v32H-5z" }))))); };
var StyledLoginOpened32 = styled_components_1.default(LoginOpened32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledLoginOpened32;
var templateObject_1;
//# sourceMappingURL=LoginOpened32.js.map